import script from "./PaperList.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperList.vue?vue&type=script&setup=true&lang=js"

import "./PaperList.vue?vue&type=style&index=0&id=e4b2c864&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4b2c864"]])

export default __exports__